import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { startWith, Observable, combineLatest } from 'rxjs';
import { Clinic } from '../clinic/clinic.store';
import { map } from 'rxjs/operators';
import {
    filterClinicsByCities,
    filterClinicsByTags,
} from '../../../core/utils/clinic-filter.utils';


@Injectable({ providedIn: 'root' })
export class ClinicFilterService {
    private readonly _activeCategoryTags = signal<string[]>([]);
    readonly activeCategoryTags = this._activeCategoryTags.asReadonly();
    readonly activeCategoryTags$ = toObservable(this.activeCategoryTags).pipe(
        startWith(this.activeCategoryTags()));

    private readonly _activeCity = signal<string | null>(null);
    readonly activeCity = this._activeCity .asReadonly();
    readonly activeCity$ = toObservable(this.activeCity).pipe(
        startWith(this.activeCity()));

    toggleTag(tag: string): void {
        this._activeCategoryTags.update(current => {
            if (current.includes(tag)) {
                return current.filter((t) => t !== tag);
            } else {
                return [...current, tag];
            }
        });
    }

    setTags(tags: string[]): void {
        this._activeCategoryTags.set(tags);
    }

    setCity(city: string | null): void {
        this._activeCity.set(city);
    }

    applySearchFilters(source$: Observable<Clinic[]>): Observable<Clinic[]> {
        return combineLatest([source$, this.activeCategoryTags$, this.activeCity$]).pipe(
            map(([clinics, tags, city]) => {
                const byTags = filterClinicsByTags(clinics, tags);
                return filterClinicsByCities(byTags,city);
            })
        );
    }
}
